/* eslint-disable */
<template>
  <div>
    <p class="title">
      Press the colour buttons on your device and see the values change live.
    </p>
    <div class="content" v-for="o in counter" :key="o.value">
      {{ o.label }} clicks: {{ o.value }}
    </div>
  </div>
  </template>
  
<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue'
import eventBus from '../plugins/eventBus';

defineOptions({
  name: 'CounterPage'
})

const counter = ref([
  {value:0,label:'red'},
  {value:0,label:'blue'},
  {value:0,label:'green'},
  {value:0,label:'yellow'},
])

const handleMessage = (data) => {
  console.log('Processing message in CounterApp:', data);

  if (data.action === 'updateColor') {
    const color = data.color;
    const found = counter.value.find((o) => o.label === color);
    if (found) {
      found.value += 1;
    }
  }
  if (data.action === 'reset') {
    counter.value = [
      {value:0,label:'red'},
      {value:0,label:'blue'},
      {value:0,label:'green'},
      {value:0,label:'yellow'},
    ]
  }
}

onMounted(()=>{
  eventBus.on('cast-message', handleMessage);
})

// Unsubscribe on unmount to avoid memory leaks
onBeforeUnmount(() => {
  eventBus.off('cast-message', handleMessage);
});

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.title{
  font-size:2em;
}
.content{
  font-size:1.4em;
}
</style>
  